<template>
  <div class="home-container">
    <Menu :images="images" v-if="menuOpen === true" @findProfile = "menuOpenHandler"  @closeMenu = "menuOpenHandler"  />
    <div  v-if="menuOpen === false" @click="menuOpenHandler" class="menu-btn-open">
      <q-btn  :class="visibleClassFive" color="primary">
        <q-icon left size="3em" name="menu" />
        <div>All profiles</div>
      </q-btn>  
    </div>
    
      <Hero />
      <About :images="images" />
      <div v-intersection.once="onIntersection" :class="visibleClassFive">

      <TomilolaAdedewe id="TomilolaAdedewe" />
      <AmudaAgneswaran id="AmudaAgneswaran" />
      <JosephAsamoah id="JosephAsamoah" />

      <Banner :profileOne="profileImgOne[2]" :url="'https://utaresources.mmu.ac.uk/as_i_am/quote-images/tomilola.png'" >
          <template v-slot:content>
              "Something I love about being from the tribe Yoruba, one of many tribes in Nigeria, is the respect and loyalty we have with one another. I admire this because such qualities are becoming more difficult to find in people today, so being brought up in a home where this is a priority makes me feel privileged and fortunate."
          </template>
          <template v-slot:person>
              – Tomilola Adedewe
          </template>
      </Banner>

      <FarinaCahm id="FarinaCahm" />
      <AngieCooke id="AngieCooke" />
      <ShuabGamote id="ShuabGamote" />


      <Banner :profileOne="profileImgOne[1]" :url="'https://images.unsplash.com/photo-1533406494543-e6cf6430f44a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80'"  >
      <template v-slot:content>
            "Bringing my whole self to work is being the positive, outgoing person I am, unapologetically, not feeling weird about saying good morning to every colleague that I pass. Bringing my whole self to work is being proud of the work that I do, the person that I am, and the organisation that I work for."
      </template>
      <template v-slot:person>
            – Shuab Gamote
      </template>
      </Banner>


      <YahyaGoga id="YahyaGoga" />
      <LolitaHall id="LolitaHall" />
      <OlamideJogunola id="OlamideJogunola" />


      <Banner :profileOne="profileImgOne[3]"  :url="'https://images.unsplash.com/photo-1643482584249-30c83aef1598?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80'"  >
          <template v-slot:content>
            "I love that I have a mixed Polish and Jamaican heritage. I love the contrast of the two cultures and the different experiences I have when visiting them both.  I love the music and dance culture of Jamaica and love the many traditions of the Polish culture."
          </template>
          <template v-slot:person>
            – Lolita Hall
          </template>
      </Banner>

      <SheriLawal id="SheriLawal" />
      <SalmaMehboob id="SalmaMehboob" />
      <LabeebaMiah id="LabeebaMiah" />


      <Banner :profileOne="profileImgOne[0]"  :url="'https://images.unsplash.com/photo-1643482584249-30c83aef1598?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80'"  >
          <template v-slot:content>
            "Being able to bring all the dimensions of my personality and character to work is being accepted for me ‘Salma’, a 3-dimensional human being, rather than ‘Asian Muslim who wears a hijab’. I am blessed that I can bring my whole self to work and be confident in presenting my own self authentically to others."
          </template>
          <template v-slot:person>
            – Salma Mehboob
          </template>
      </Banner>    

      <ManjuPallam id="ManjuPallam" />
      <MonaPatel id="MonaPatel" />
      <SundasRashid id="SundasRashid" />

      <Banner :profileOne="profileImgOne[5]"  :url="'https://images.unsplash.com/photo-1643482584249-30c83aef1598?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2340&q=80'"  >
          <template v-slot:content>
            "Being brown. Being a woman. Being disabled. Being a parent. Being an activist and an ally. Regardless of the mental and physical challenges that all of these bring, I am proud of them all."
          </template>
          <template v-slot:person>
            – Mona Patel
          </template>
      </Banner>    

      <JacklynSiuYuinTan id="JacklynSiuYuinTan" />
      <IwiUgiagbeGreen id="IwiUgiagbeGreen" />

      <div class="acknowledgment-container">

          <div class="acknowledgment">
              <p>Photographs taken by <b>Elliott Howard</b>:</p>
              <p><a target="blank" href="https://www.instagram.com/el.shot.that/">Instagram</a></p>
              <p><a target="blank" href="https://protect-eu.mimecast.com/s/pMJfCOEY1SwjqznCEUMj4?domain=elliotthoward.myportfolio.com">Website</a></p>
          </div>

      </div>

      </div>
    </div>
    <Footer />
</template>

<script>
import { reactive, computed, ref } from 'vue'
import Carousel from '../components/Carousel.vue'
import { scroll } from 'quasar'
import { useRouter } from 'vue-router'
import Hero from '../components/Hero'
import AmudaAgneswaran from '../components/interviews/AmudaAgneswaran.vue'
import AngieCooke from '../components/interviews/AngieCooke.vue'
import LabeebaMiah from '../components/interviews/LabeebaMiah.vue'
import LisaBach from '../components/interviews/LisaBach.vue'
import TomilolaAdedewe from '../components/interviews/TomilolaAdedewe.vue'
import JosephAsamoah from '../components/interviews/JosephAsamoah.vue'
import SundasRashid from '../components/interviews/SundasRashid.vue'
import MishalSaeed from '../components/interviews/MishalSaeed.vue'
import SheriLawal from '../components/interviews/SheriLawal.vue'
import IwiUgiagbeGreen from '../components/interviews/IwiUgiagbeGreen.vue'
import SalmaMehboob from '../components/interviews/SalmaMehboob.vue'
import ShuabGamote from '../components/interviews/ShuabGamote.vue'
import OlamideJogunola from '../components/interviews/OlamideJogunola.vue'
import ManjuPallam from '../components/interviews/ManjuPallam.vue'
import LolitaHall from '../components/interviews/LolitaHall.vue'
import FarinaCahm from '../components/interviews/FarinaCahm.vue'
import MonaPatel from '../components/interviews/MonaPatel.vue'
import JacklynSiuYuinTan from '../components/interviews/JacklynSiuYuinTan.vue'
import YahyaGoga from '../components/interviews/YahyaGoga.vue'
import Footer from '../components/Footer.vue'
import Menu from '../components/Menu.vue'
import About from '../components/About.vue'
import Banner from '../components/Banner.vue'
import imageProfiles from '../composable/profiles'


export default {
  components: {
    Menu,
    Hero, 
    AmudaAgneswaran,
    AngieCooke,
    LabeebaMiah,
    LisaBach,
    LolitaHall,
    TomilolaAdedewe,
    MonaPatel,
    IwiUgiagbeGreen,
    SundasRashid,
    JosephAsamoah,
    MishalSaeed,
    SheriLawal,
    OlamideJogunola,
    SalmaMehboob,
    ManjuPallam,
    About,
    YahyaGoga,
    Banner,
    Footer,
    ShuabGamote,
    JacklynSiuYuinTan,
    FarinaCahm
  },
  setup () {

    const menuOpen = ref(false)

    const router  = useRouter()

    const profileImgOne = ref(['https://utaresources.mmu.ac.uk/as_i_am/quote-images/salma.png', 'https://utaresources.mmu.ac.uk/as_i_am/quote-images/shuab.png', 'https://utaresources.mmu.ac.uk/as_i_am/quote-images/tomilola.png', 'https://utaresources.mmu.ac.uk/as_i_am/quote-images/lolita.png', 'https://utaresources.mmu.ac.uk/as_i_am/quote-images/jacklyn.png', 'https://utaresources.mmu.ac.uk/as_i_am/quote-images/mona.png'])

    const { getScrollTarget } = scroll
        const visible = ref(true)
        const onIntersection = (entry) => {
            const mediaQuery = window.matchMedia('(min-width: 600px)')
            mediaQuery.matches ? visible.value = entry.isIntersecting : visible.value = true 
        }

        const visibleClassFive = computed(() => { 
            if(visible.value) {
                return 'show-five'
            } else {
                return 'hide-five'
            }
        })

    const { images } = imageProfiles()

    const bounceImage = () => {
        el.classList.add('animate-bounce')
    }


    const menuOpenHandler = (anchor) => {
        menuOpen.value = !menuOpen.value

        if(menuOpen.value === true) {
          // document.querySelector("body").style.height = '100%';
              document.querySelector("body").style.overflowY = 'hidden';

        } else {
          // document.querySelector("body").style.height = 'auto';
              document.querySelector("body").style.overflowY = 'visible';
              document.querySelector("body").style.overflowY = 'scroll';
              
              if(menuOpen.value) {
                }
        }

         if(!menuOpen.value && anchor) {
          document.body.scrollTop = 0;
          document.getElementById(anchor).scrollIntoView({behavior: "smooth"});
        }
    }

    return { 
    menuOpen,
    menuOpenHandler, 
    router, 
    images, 
    bounceImage,
    getScrollTarget,
    visibleClassFive,
    onIntersection,
    profileImgOne
    }
  }
}
</script>


